module.exports = __webpack_public_path__ + "static/media/xdf.6ac5f1d0.jpg";